import { render } from "./BuyComplect.vue?vue&type=template&id=48b2dd70&scoped=true"
import script from "./BuyComplect.vue?vue&type=script&lang=js"
export * from "./BuyComplect.vue?vue&type=script&lang=js"

import "./BuyComplect.vue?vue&type=style&index=0&id=48b2dd70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b2dd70"]])

export default __exports__